var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_22086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 70V0H70V70H0Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.574 52.2098C46.9173 54.3876 48.377 56.4742 51.4693 56.4742C54.0665 56.4742 55.4292 55.1858 55.4292 53.4033C55.4292 51.2701 54.0199 50.5126 51.1626 49.2706L49.5961 48.6041C45.0751 46.6899 42.0683 44.2913 42.0683 39.2247C42.0683 34.5553 45.6497 31.0019 51.246 31.0019C55.2312 31.0019 58.0944 32.3795 60.1598 35.9871L55.2797 39.1007C54.2063 37.1864 53.0455 36.4328 51.246 36.4328C49.4097 36.4328 48.247 37.5894 48.247 39.1007C48.247 40.9684 49.4117 41.7241 52.1001 42.8808L53.6667 43.5473C58.9951 45.8122 62 48.1256 62 53.3258C62 58.9291 57.5664 62 51.6149 62C45.7934 62 42.4876 59.0841 40.6474 55.4745L45.574 52.2098ZM23.0839 52.3687C24.0661 54.1241 25.5588 55.4745 27.7057 55.4745C29.7595 55.4745 30.9416 54.6646 30.9416 51.5162V31H37.4115V52.5082C37.4115 59.0318 33.6204 62 28.0843 62C23.0819 62 19.4714 58.6171 18 55.4745L23.0839 52.3687Z",
    fill: "#000001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_22086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/Javascript.f3f720062f2f4fce48b53bf127b50c2c.svg";
export { ForwardRef as ReactComponent };